import React from "react";
import { ImageGeneratorCatalogAsset } from "../../app/api/imageGenerator";
import ImageGeneratorSelectionTick from "./ImageGeneratorSelectionTick";

type Props = {
  asset: ImageGeneratorCatalogAsset;
  previewUrl?: string;
  isSelected: boolean;
  choiceLocked: boolean;
  isMuted: boolean;
  onToggle: (stem: string) => void;
  aspectClassName?: string;
  imageFit?: "cover" | "contain";
  caption?: string;
};

const ImageGeneratorPreferenceTile: React.FC<Props> = ({
  asset,
  previewUrl,
  isSelected,
  choiceLocked,
  isMuted,
  onToggle,
  aspectClassName = "aspect-[2/3]",
  imageFit = "cover",
  caption,
}) => (
  <button
    type="button"
    onClick={() => onToggle(asset.stem)}
    disabled={choiceLocked}
    aria-pressed={isSelected}
    title={
      choiceLocked
        ? "Pattern tiles are only used when you choose one yourself."
        : caption || asset.stem
    }
    className={`w-full text-left outline-none transition-all focus-visible:outline-none ${
      choiceLocked
        ? "cursor-not-allowed opacity-40 grayscale"
        : isMuted
          ? "opacity-50 hover:opacity-100"
          : ""
    }`}
  >
    <span
      className={`relative block ${aspectClassName} w-full overflow-hidden rounded-2xl border bg-gray-100 transition-all ${
        isSelected
          ? "border-2 border-[#737373]"
          : "border border-[#737373]/50 hover:border-[#737373]"
      }`}
    >
      {previewUrl ? (
        <img
          src={previewUrl}
          alt={caption || asset.stem}
          className={`h-full w-full ${
            imageFit === "contain" ? "object-contain" : "object-cover"
          }`}
        />
      ) : (
        <span className="flex h-full w-full items-center justify-center bg-gray-100 px-2 text-center">
          <span className="break-all text-[10px] leading-tight text-gray-500">
            {asset.stem}
          </span>
        </span>
      )}
      {isSelected ? <ImageGeneratorSelectionTick /> : null}
    </span>
    {caption ? (
      <span className="mt-2 block text-center text-xs font-normal leading-snug text-secondary">
        {caption}
      </span>
    ) : null}
  </button>
);

export default ImageGeneratorPreferenceTile;
